import React from "react";
import { SortableContext, verticalListSortingStrategy } from "@dnd-kit/sortable";
import { useDroppable } from "@dnd-kit/core";
import { Box, Tabs, Tab, Button, IconButton, Typography, TextField } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import SortableField from "./SortableField";

/** Área central do builder: páginas + lista de campos arrastáveis. */
export default function Canvas({
  pages, currentPageId, onChangePage, onAddPage, onDeletePage, onRenamePage,
  fields, selectedFieldId, onSelectField, onDeleteField, onDuplicateField,
}) {
  const { setNodeRef, isOver } = useDroppable({ id: "page-dropzone" });
  const currentPage = pages.find((p) => p.id === currentPageId) || pages[0];

  return (
    <Box>
      <Box sx={{ display: "flex", alignItems: "center", borderBottom: "1px solid #eee", mb: 2 }}>
        <Tabs value={currentPageId} onChange={(_, v) => onChangePage(v)} variant="scrollable" scrollButtons="auto" sx={{ flex: 1 }}>
          {pages.map((p) => (
            <Tab key={p.id} value={p.id} label={p.title} />
          ))}
        </Tabs>
        <Button size="small" startIcon={<AddIcon />} onClick={onAddPage}>Página</Button>
      </Box>

      {currentPage && (
        <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2 }}>
          <TextField size="small" label="Título da página" value={currentPage.title}
            onChange={(e) => onRenamePage(currentPage.id, e.target.value)} sx={{ flex: 1 }} />
          {pages.length > 1 && (
            <IconButton color="error" onClick={() => onDeletePage(currentPage.id)}>
              <DeleteIcon />
            </IconButton>
          )}
        </Box>
      )}

      <Box
        ref={setNodeRef}
        sx={{
          minHeight: 300, p: 2, borderRadius: 1,
          border: isOver ? "2px dashed #3f51b5" : "2px dashed transparent",
          background: isOver ? "#f5f6ff" : "transparent",
        }}
      >
        <SortableContext items={fields.map((f) => f.id)} strategy={verticalListSortingStrategy}>
          {fields.map((field) => (
            <SortableField
              key={field.id}
              field={field}
              selected={field.id === selectedFieldId}
              onSelect={onSelectField}
              onDelete={onDeleteField}
              onDuplicate={onDuplicateField}
            />
          ))}
        </SortableContext>

        {fields.length === 0 && (
          <Box sx={{ textAlign: "center", color: "#999", py: 6 }}>
            <Typography variant="body2">
              Arraste campos da paleta para cá, ou clique em um tipo de campo para adicionar.
            </Typography>
          </Box>
        )}
      </Box>
    </Box>
  );
}
